export class EngineDefaultParams {
  static defaultItineraries: number[] = [2, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21, 23, 24, 25];
}
